
function Home(){

    this.build();
    barbaCallbacks.push(this);

}

Home.prototype.build = function(){

    $('#home-form-submit').on('click', function(){
        let link = $('#_h_search').val();
	    window.location.href = link;
    });


    $('.home-header-link, .video-play-btn').magnificPopup({
        preloader: false,
        type: 'inline'
    });

    $('.home-banner-video').magnificPopup({
        preloader: false,
        items: [
            {
                src: '#video-modal-2',
                type: 'inline'
            }
        ]
    });

};
